import styled from 'styled-components';

const Wrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
`;

const TextWrapper = styled.p`
    position: absolute;
    text-align: center;
    padding: 16px;
    border-radius: 4px;
    color: white;
    background-color: rgba(0, 0, 0, 0.6);
`;

const StyledImg = styled.img`
    width: 80%;
    border-radius: 16px;
`;

const NoLicense = ({ image, active = 'this section' }) => {
    return (
        <Wrapper>
            <TextWrapper>
                Your license doesn't allow to see {active}.
                <br />
                Contact sales if you want to broaden your license.
            </TextWrapper>
            {image && <StyledImg src={image.src} alt={image.alt} />}
        </Wrapper>
    );
};

export default NoLicense;
